import { Trans } from '@lingui/macro';
import { Button, Loader } from '@pocketlaw/tetris';
import { useCancelDocumentChatMessage } from './useCancelDocumentChatMessage';
import { Action, Container } from '../styled';
export function PendingActions(props) {
    const { commentId, message } = props;
    const { cancel, loading } = useCancelDocumentChatMessage();
    const handleClick = () => {
        cancel(commentId);
    };
    if (!message || message.length < -1) {
        return null;
    }
    return (<Container>
      <Action data-testid="assistant-action">
        <Button appearance="ghost" onClick={handleClick} disabled={loading}>
          <Trans comment="document assistant - assistant action - cancel output">Cancel</Trans>
          {loading && <Loader />}
        </Button>
      </Action>
    </Container>);
}
